import { gql, useLazyQuery } from '@apollo/client';
import { AnyObject } from '../../../models/types';
import {ListSecurityConfigsVars} from "../Account/useListSecurityConfigsQuery";

export interface ListCollectionGroupsVars {
    awsAccountId: string;
}

const LIST_COLLECTION_GROUPS = gql`
    query ListCollectionGroups(
            $awsAccountId: String
        ){
        listCollectionGroups(
            awsAccountId: $awsAccountId
        )
    }
`;

export const useListCollectionGroupsQuery = () => {
    return useLazyQuery<AnyObject, ListCollectionGroupsVars>(LIST_COLLECTION_GROUPS, {
        errorPolicy: 'all',
    });
};